/**
 * Константы для API endpoints модуля journals
 */

export const API_ENDPOINTS = {
  journals: '/api/journal/journal',
  journal: (id: number) => `/api/journal/journal/${id}`,
  journalEntries: (id: number) => `/api/journal/journal/${id}/entries`,
  journalEntry: (journalId: number, entryId: number) =>
    `/api/journal/journal/${journalId}/entries/${entryId}`,
  journalEntryAttachFile: (journalId: number, entryId: number) =>
    `/api/journal/journal/${journalId}/entries/${entryId}/attach-file`,
  journalAttributeCreationList: (journalId: number) =>
    `/api/journal/journal/${journalId}/attributes/creation-list/`,
  journalAttributeChoices: (journalId: number) =>
    `/api/journal/journal/${journalId}/attributes/attribute-choices/`,
  journalExport: (id: number) => `/api/journal/journal/${id}/export`,
} as const

/**
 * Константы для задержек и таймаутов
 */
export const DEBOUNCE_DELAY_MS = 300 // Оптимальная задержка для поиска
export const TOAST_DURATION_MS = 3000 // Длительность показа уведомлений
